'use strict';

/**
 * Very simple helper to deal with with different resolutions
 *
 * @example <caption>usage of callbacks</caption>
 *
 * var deviceState = require('components/device-state');
 *
 * deviceState.mobile.addListener(deviceState.onEnter(function() {
 *   deviceState.isMobile // true
 *   deviceState.isTablet // false
 *   deviceState.isDesktop // false
 *   deviceState.isMobileOrTablet // true
 *   // will be called for mobile devices only
 * });
 *
 * deviceState.tablet.addListener(deviceState.onEnter(function() {
 *   deviceState.isTablet // true
 *   deviceState.isMobile // false
 *   deviceState.isDesktop // false
 *   deviceState.isMobileOrTablet // true
 *   // will be called for tablets only
 * });
 *
 * deviceState.mobile.addListener(deviceState.onLeave(function() {
 *   deviceState.isMobile // false
 *   // will be called once the browser windows gets bigger than "mobile" resolution
 * });
 *
 *
 * @example <caption>usage of state indicators</caption>
 *
 * // note that values of there properties might change along with resolution
 * deviceState.isMobile // true for mobile devices
 * deviceState.isTablet // true for tablets
 * deviceState.isDesktop // true for desktops
 * deviceState.isMobileOrTablet // true for tablets and mobile devices
 */

global.matchMedia = global.matchMedia || function() {
    return {
        matches: false,
        addListener: function() {
        },
        removeListener: function() {
        }
    };
};

const states = {
    mobile: global.matchMedia('(max-width: 767px)'),
    tablet: global.matchMedia('(min-width: 768px) and (max-width: 1199px)'),
    desktop: global.matchMedia('(min-width: 1200px)'),
    mobileOrTablet: global.matchMedia('(max-width: 1199px)')
};

export let isMobile = states.mobile.matches;
export let isTablet = states.tablet.matches;
export let isDesktop = states.desktop.matches;
export let isMobileOrTablet = states.mobileOrTablet.matches;

/**
 * Produces a function that gets called only if browser enters given media query
 * @param {Function} callback
 * @returns {Function}
 */
export function onEnter(callback) {
    return function(event) {
        if (event.matches) {
            callback.apply(this, arguments);
        }
    }
};

/**
 * Produces a function that gets called only if browser leaves given media query
 * @param {Function} callback
 * @returns {Function}
 */
export function onLeave(callback) {
    return function(event) {
        if (!event.matches) {
            callback.apply(this, arguments);
        }
    }
}

var registerListener = function(state, callback) {
    if (states[state].matches) {
        callback();
    }
    states[state].addListener(onEnter(callback));
};

export function onMobile(callback) {
    registerListener('mobile', callback);
}

export function onTablet(callback) {
    registerListener('tablet', callback);
}

export function onDesktop(callback) {
    registerListener('desktop', callback);
}

export function onMobileOrTablet(callback) {
    registerListener('mobileOrTablet', callback);
};
